module.exports = __webpack_public_path__ + "img/17_pc.16c9f19a.gif";